import DayJS from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isYesterday from 'dayjs/plugin/isYesterday'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import isBetween from 'dayjs/plugin/isBetween'
import isToday from 'dayjs/plugin/isToday'

// Importar locales específicos
import 'dayjs/locale/es'
import 'dayjs/locale/en'
import 'dayjs/locale/pt'

import i18n from '../i18n'

DayJS.extend(timezone)
DayJS.extend(utc)
DayJS.extend(duration)
DayJS.extend(customParseFormat)
DayJS.extend(isSameOrBefore)
DayJS.extend(isSameOrAfter)
DayJS.extend(isYesterday)
DayJS.extend(relativeTime)
DayJS.extend(localizedFormat)
DayJS.extend(isBetween)
DayJS.extend(isToday)

// Obtener el locale correcto según el idioma actual de i18n
const supportedLocales = ['es', 'en', 'pt'];

const getCurrentLocale = () => {
    const currentLang = i18n.language || i18n.resolvedLanguage || 'en'
    // Extraer solo el código de idioma base (ej: "pt-BR" -> "pt", "en-US" -> "en")
    const baseLang = currentLang.split('-')[0].toLowerCase()
    return supportedLocales.includes(baseLang) ? baseLang : 'en'
}

// Configurar locale global de DayJS
const setGlobalLocale = () => {
    const locale = getCurrentLocale()
    DayJS.locale(locale)
}

// Configurar locale inicial
setGlobalLocale()

// Escuchar cambios de idioma en i18n
i18n.on('languageChanged', setGlobalLocale)

// Función helper para crear fechas con locale correcto
export const createLocalizedDate = (date?: DayJS.ConfigType) => {
    return DayJS(date).locale(getCurrentLocale())
}

// Función helper para fechas UTC con locale
export const localeUtcDate = (date: DayJS.Dayjs) => {
    return date.utc().locale(getCurrentLocale())
}

// Función helper para formatear fechas con locale
export const formatWithLocale = (date: DayJS.ConfigType, format: string) => {
    return DayJS(date).locale(getCurrentLocale()).format(format)
}

// Función helper para fechas relativas con locale
export const relativeTimeWithLocale = (date: DayJS.ConfigType, baseDate?: DayJS.ConfigType) => {
    const locale = getCurrentLocale()
    const localizedDate = DayJS(date).locale(locale)

    if (baseDate) {
        const localizedBaseDate = DayJS(baseDate).locale(locale)
        return localizedDate.to(localizedBaseDate)
    }

    return localizedDate.fromNow()
}

export default DayJS
